import Vue from 'vue'
import Vuex from 'vuex'
// 引入持久化库
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
    // 使用插件
    plugins: [persistedState({ storage: window.sessionStorage })],
    state: {
        teacherVersion: ''
    },
    getters: {
        getTeacherVersion: state => state.teacherVersion
        
    },
    actions: {
        setTeacherVersion({commit},teacherVersion) {
            commit('mutationTeacherVersion',teacherVersion)
        }
    },
    mutations: {
        mutationTeacherVersion(state,teacherVersion) {
            state.teacherVersion = teacherVersion
        }
    }
  })

  export default store


// WEBPACK FOOTER //
// ./src/store/index.js